/* eslint-disable implicit-arrow-linebreak */
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Modal, ModalFooter, Button, Icon } from '@folio/stripes/components';
import {
  exportErrorsToText,
  exportErrorsToPDF,
  copyErrorsToClipboard,
} from './ErrorExportUtils';
import ErrorDisplay from './ErrorDisplay';

const ErrorDetailsModal = ({
  open,
  onClose,
  errors,
  contextData,
  titleKey,
  mode,
}) => {
  const intl = useIntl();

  // Handler functions using the utility functions
  const handleExportText = () =>
    exportErrorsToText(errors, contextData, mode, intl);
  const handleExportPDF = () =>
    exportErrorsToPDF(errors, contextData, mode, intl);
  const handleCopyToClipboard = () => copyErrorsToClipboard(errors, intl);

  return (
    <Modal
      open={open}
      onClose={onClose}
      label={
        <FormattedMessage
          id={titleKey}
          defaultMessage="Error Details ({count})"
          values={{ count: errors.length }}
        />
      }
      size="large"
      footer={
        <ModalFooter>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Button buttonStyle="default" onClick={handleExportText}>
              <Icon icon="document" />
              <FormattedMessage
                id="ui-plugin-inventory-templates.errorDetails.exportText"
                defaultMessage="Export Text"
              />
            </Button>

            <Button buttonStyle="default" onClick={handleExportPDF}>
              <Icon icon="download" />
              <FormattedMessage
                id="ui-plugin-inventory-templates.errorDetails.exportPDF"
                defaultMessage="Export PDF"
              />
            </Button>
            <Button buttonStyle="primary" onClick={handleCopyToClipboard}>
              <Icon icon="duplicate" />
              <FormattedMessage
                id="ui-plugin-inventory-templates.errorDetails.copy"
                defaultMessage="Copy Errors"
              />
            </Button>
          </div>

          <Button onClick={onClose}>
            <FormattedMessage
              id="ui-plugin-inventory-templates.errorDetails.close"
              defaultMessage="Close"
            />
          </Button>
        </ModalFooter>
      }
    >
      <div style={{ padding: '20px' }}>
        <ErrorDisplay errors={errors} />
      </div>
    </Modal>
  );
};

ErrorDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
      displayMessage: PropTypes.string,
      category: PropTypes.string,
      operation: PropTypes.string,
      timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  contextData: PropTypes.shape({}),
  titleKey: PropTypes.string,
  mode: PropTypes.oneOf(['create', 'edit', 'generic']),
};

ErrorDetailsModal.defaultProps = {
  errors: [],
  contextData: {},
  titleKey: 'ui-plugin-inventory-templates.errorDetails.modalTitle',
  mode: 'generic',
};

export default ErrorDetailsModal;
